// extracted by mini-css-extract-plugin
module.exports = {"btn":"ChatwootFallback_btn__Tt1ru"};